import request from '../util/request';

const haveVideoDeviceUrl = '/iot/equipApi/findCameraEquip' //查询可监控设备信息 右下角全部带摄像头的设备
const mapHoverUrl = '/iot/equipApi/statEquipByArea'; //地图放上去显示的数据
const mapClickUrl = '/iot/equipApi/statEquipByOrg'; // 地图下方表格数据
const onLineNumberUrl = '/iot/equipApi/statEquipByOnline' //设备在线离线数 左上角水球图
const allDeviceUrl = '/iot/equipApi/findEquipIot' //左下角全部设备信息
const loginUrl = '/iot/equipApi/login'

const deviceWarningInfoUrl = '/iot/equipApi/findEquipAlertInfo' //查询设备报警信息 -------------------------------------还未调通
const searchDeviceInfoUrl = '/iot/equipApi/findEquipByOrgUuidAndAreaName' //根据归属单位+区域查询设备信息
const updateDeviceInfoUrl = '/iot/equipApi/updateEquipAlertStatus' //更新设备报警状态

const getWarningInfoUrl = '/iot/equipApi/findWaitEquipAlertInfo' //查询设备报警
const getWarningNumberUrl = '/iot/equipApi/statAlertByIsPass' //获取报警处理数 和 未 处理数

    // /iot/equipApi/findEquipByOrgUuidAndAreaName
// 根据归属单位+区域查询设备信息

export function getWarningNumber (data) {
    return request({
        url: getWarningNumberUrl,
        method: 'post',
        data:data
    })
}

//更新设备报警状态
export function getWarningInfo (data) {
    return request({
        url: getWarningInfoUrl,
        method: 'post',
        data:data
    })
}

//更新设备报警状态
export function updateDeviceInfo (data) {
    return request({
        url: updateDeviceInfoUrl,
        method: 'post',
        data:data
    })
}

//根据归属单位+区域查询设备信息
export function searchDeviceInfo (data) {
    return request({
        url: searchDeviceInfoUrl,
        method: 'post',
        data:data
    })
}


//查询设备报警信息
export function deviceWarningInfo (data) {
    return request({
        url: deviceWarningInfoUrl,
        method: 'post',
        data:data
    })
}

export function allDevice (data) {
    return request({
        url: allDeviceUrl,
        method: 'post',
        data:data
    })
}

export function onLineNumber (data) {
    return request({
        url: onLineNumberUrl,
        method: 'post',
        data:data
    })
}

export function haveVideoDevice (data) {
    return request({
        url: haveVideoDeviceUrl,
        method: 'post',
        data:data
    })
}

export function mapHoverData (data) {
    return request({
        url: mapHoverUrl,
        method: 'post',
        data:data
    })
}

export function mapClickData (data) {
    return request({
        url: mapClickUrl,
        method: 'post',
        data:data
    })
}

export function login (data) {
    return request({
        url: loginUrl,
        method: 'post',
        data:data
    })
}
